import { ButtonLink, Card } from '@ingrid/luterkort-react';

import { useTranslation } from '~src/i18n/use-translation';

import { useShipmentFormContext } from '../types';
import { AddressCard } from './address-card';

export function Addresses() {
  const { t } = useTranslation();
  const { watch, setValue } = useShipmentFormContext();
  const [addressFrom, addressTo, addressReturn, customerAddress] = watch([
    'contact_from',
    'contact_to',
    'contact_return',
    'customer_info.contact',
  ]);

  return (
    <Card.Wrapper as="section">
      <Card.Header>{t('common.addresses')}</Card.Header>
      <Card.Grid css={{ width: '640px' }}>
        <AddressCard type="contact_from" />
        <AddressCard type="customer_info.contact" />
        <AddressCard
          actions={
            addressFrom && !addressReturn ? (
              <ButtonLink onClick={() => setValue('contact_return', addressFrom, { shouldDirty: true })}>
                {t('shipments.address.useConsignorAddress')}
              </ButtonLink>
            ) : null
          }
          type="contact_return"
        />
        <AddressCard
          actions={
            customerAddress && !addressTo ? (
              <ButtonLink onClick={() => setValue('contact_to', customerAddress, { shouldDirty: true })}>
                {t('shipments.address.useConsigneeAddress')}
              </ButtonLink>
            ) : null
          }
          type="contact_to"
        />
      </Card.Grid>
    </Card.Wrapper>
  );
}
